import React from "react";
import { LightningPattern, Pattern, PatternType, TwistedStripePattern } from "../types/pattern.model";
import LightningPreview from "../patterns/LightningPreview";
import TwistedStripePreview from "../patterns/TwistedStripePreview";

interface PatternPreviewProps {
  pattern: Pattern;
  type: PatternType;
}

const PatternPreview: React.FC<PatternPreviewProps> = ({ pattern, type }) => {
  switch (type) {
    case 'lightning':
      const {outside, middle, inside} = pattern as LightningPattern;
      return <LightningPreview outside={outside} middle={middle} inside={inside} />;
    case 'twisted-stripe':
      const {stripe1, stripe2, stripe3, stripe4, stripe5} = pattern as TwistedStripePattern;
      return <TwistedStripePreview stripe1={stripe1} stripe2={stripe2} stripe3={stripe3} stripe4={stripe4} stripe5={stripe5} />;
  }
};

export default PatternPreview;
